import React, { useContext } from 'react';
import { ErrorBoundary } from '../ErrorBoundary';
import { IWithErrorHandlingProps, withErrorHandling } from '../withErrorHandling';
import { IUseApiProps } from '../useApi';
import { OrbUserContext } from '../OrbUserContext';
import TrackRisksReportCls from './TrackRisksReportCls';

export interface IGiaaReportProps extends IUseApiProps, IWithErrorHandlingProps {
}

const TrackRisksReport = (props: IGiaaReportProps) => {
    const { userPermissions } = useContext(OrbUserContext);
    return (
        <ErrorBoundary>
            <TrackRisksReportCls
                userPermissions={userPermissions}
                {...props}
            />
        </ErrorBoundary>
    );
};

export default withErrorHandling(TrackRisksReport);
